/**
 * Created by kz on 28.06.17.
 */
import * as api from '@api/companies'

export const all = ({commit}, params) => {
  commit('loading', true, {root: true})
  return api.getCompanies(params)
    .then(({data}) => {
      commit('receive', data)
      commit('loading', false, {root: true})
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/actions.js